export default __webpack_public_path__ + "static/Win valuable contracts with precise cost estimates @2x-ede02c8805293e9cff1fa9525fb47e38.png";